import {Collection} from '../models/collection';
import {formatDate} from '../util';

import './CSS/CollectionView.css';

interface CollectionViewProps {
    collection: Collection;
    onClickDeleteButton: (collection: Collection) => void;
    onClickEditButton: (collection: Collection) => void;
    onClickAddDataButton: (collection: Collection) => void;
    onClickReadDataButton: (collection: Collection) => void;
}

const CollectionView: React.FC<CollectionViewProps> = (props: CollectionViewProps) => {
    const collection = props.collection;
    let createdAt = new Date('0000-00-00 00:00:00');
    if (collection.created_at !== undefined) {
        createdAt = new Date(collection.created_at);
    }

    const onClickDeleteButton = () => {
        props.onClickDeleteButton(collection);
    };

    const onClickEditButton = () => {
        props.onClickEditButton(collection);
    };

    const onClickAddDataButton = () => {
        props.onClickAddDataButton(collection);
    };

    const onClickReadDataButton = () => {
        props.onClickReadDataButton(collection);
    };

    const copyId = () => {
        if (collection.collection_id !== undefined) {
            navigator.clipboard.writeText(collection.collection_id);
        }
    };

    return (
        <div className='collection-view'>
            <div className='collection-header'>
                <div>
                    <div className='collection-view-name'>{collection.collection_name}</div>
                    <div className='collection-view-created-date'>{formatDate(createdAt, 'yyyy-MM-dd HH:mm:ss')}</div>
                </div>
                <div className='collection-view-control'>
                    <span className='material-symbols-outlined symbol-animation' onClick={onClickReadDataButton}>
                        monitoring
                    </span>
                    <span className='material-symbols-outlined symbol-animation' onClick={onClickEditButton}>
                        edit
                    </span>
                    <span className='material-symbols-outlined symbol-animation' onClick={onClickAddDataButton}>
                        add
                    </span>
                    <span className='material-symbols-outlined symbol-animation' onClick={onClickDeleteButton}>
                        delete
                    </span>
                </div>
            </div>
            <div className='collection-view-id'>
                <div className='input-group'>
                    <label>Collection ID:</label>
                    <input type='text' value={collection.collection_id} readOnly></input>
                    <span className='material-symbols-outlined' onClick={copyId}>
                        content_copy
                    </span>
                </div>
            </div>
        </div>
    );
};

export default CollectionView;
